<div class="header">
    <div class="header-block">
        <div class="buttons-left">
            <a *ngIf="showCloseButton" class="header-button header-button-left header-button-close"
               (click)="closeWidget()">
                <img alt="" class="close-btn widget-close" src="./assets/img/icon-close.svg">
            </a>
            <a *ngIf="!showCloseButton && backRoute" [relativeTo]="backRoute" [routerLink]="['.']"
               class="header-button header-button-left header-button-back">
                <mat-icon>arrow_back</mat-icon>
            </a>
        </div>

        <a [relativeTo]="rootRoute" [routerLink]="['.']" class="logo">
            <img [src]="logoImgSrc" alt="" class="logo-image">
        </a>

        <div class="buttons-right">
            <a *ngIf="showAuthButtons" (click)="goProfile()"
               class="header-button header-button-right">
                <img alt="" height="24" src="./assets/img/authorized.svg" width="24">
            </a>
        </div>
    </div>
</div>
